import { render, staticRenderFns } from "./header.vue?vue&type=template&id=19c35614&scoped=true&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style1 from "./header.vue?vue&type=style&index=1&id=19c35614&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c35614",
  null
  
)

export default component.exports